import { heroChips, heroStats } from '@/mocks/homeData';

function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[660px] flex items-end overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20editorial%20texture%20of%20stacked%20folded%20newspapers%20and%20magazines%20in%20deep%20crimson%20charcoal%20and%20warm%20amber%20tones%2C%20dramatic%20low%20key%20lighting%2C%20stylized%20grainy%20print%20composition%20with%20soft%20haze%2C%20no%20faces%2C%20no%20text&width=1600&height=900&seq=hlws-hero-01&orientation=landscape"
        alt="黑料网社 首页背景"
        title="黑料网社 板块分区导航"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 to-transparent" />

      <div className="relative w-full px-4 md:px-8 pb-12 md:pb-16 pt-28 md:pt-32">
        <div className="w-full max-w-6xl">
          <div className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-accent-500/20 border border-accent-400/40 text-accent-100 text-xs font-label backdrop-blur animate-fade-in">
            <i className="ri-stack-line" />
            分区 · 频道 · 子版 一站导航
          </div>

          <h1 className="mt-5 font-heading font-bold text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight max-w-4xl animate-fade-up">
            黑料网社
            <span className="block mt-2 text-primary-200 text-2xl md:text-3xl lg:text-4xl">
              板块分区一目了然，想逛哪个区直接点
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/85 font-label animate-fade-up">
            把黑料网社的频道、子版与主页入口全部整理在一屏之内：栏目导航清晰，新老用户都能快速找到对味的料。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-xl animate-fade-up">
            <label className="flex items-center gap-2 flex-1 h-12 px-4 rounded-md bg-background-50/95 border border-background-200">
              <i className="ri-search-line text-foreground-500" />
              <input
                type="text"
                placeholder="输入分区、频道或关键词"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none font-label placeholder:text-foreground-400"
              />
            </label>
            <a
              href="#districts"
              className="inline-flex items-center justify-center gap-1 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              查看全部分区
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <div className="mt-7 flex flex-wrap gap-2 animate-fade-in">
            <span className="text-xs font-label text-background-100/70 py-1.5">快捷入口</span>
            {heroChips.map((chip) => (
              <a
                key={chip}
                href="#districts"
                className="px-3 py-1.5 rounded-full text-xs font-label text-background-50 bg-background-50/10 border border-background-50/25 hover:bg-accent-500 hover:border-accent-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                {chip}
              </a>
            ))}
          </div>

          <dl className="mt-9 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-5 max-w-3xl border-t border-background-50/20 pt-6">
            {heroStats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs font-label text-background-100/70">{item.label}</dt>
                <dd className="mt-1 font-heading text-2xl md:text-3xl font-bold text-background-50">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}

export default Hero;